import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import { parseDuplicateParameters } from '../../utility/uiUtils';
import { API_SURVEYS_HISTORY } from '../../constants/apiRoutes';
import { SURVEYS_HISTORY_DEFAULT_PARAMS } from '../../constants/pages';

// ------------------------------------
// Constants
// ------------------------------------

const SET_SURVEYS_HISTORY = 'SET_SURVEYS_HISTORY';
const LOAD_MORE_SURVEYS_HISTORY = 'LOAD_MORE_SURVEYS_HISTORY';

const initialState = {};

// ------------------------------------
// Actions
// ------------------------------------

const setSurveysHistory = createAction(SET_SURVEYS_HISTORY);
const loadMoreSurveysHistory = createAction(LOAD_MORE_SURVEYS_HISTORY);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_SURVEYS_HISTORY]: (state, { payload }) => {
    return payload;
  },
  [LOAD_MORE_SURVEYS_HISTORY]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
      results: state.results
        ? [...state.results, ...payload.results]
        : [...payload.results],
    };
  },
};

// ------------------------------------
// API calls
// ------------------------------------

export const getSurveysHistory = (
  dispatch,
  isLoadMore = false,
  params = {}
) => {
  return http
    .get(API_SURVEYS_HISTORY, {
      params: { ...SURVEYS_HISTORY_DEFAULT_PARAMS, ...params },
      paramsSerializer: data => parseDuplicateParameters(data),
    })
    .then(({ data }) => {
      dispatch(
        isLoadMore ? loadMoreSurveysHistory(data) : setSurveysHistory(data)
      );
    });
};

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearSurveysHistory = () => setSurveysHistory(initialState);
